import React, { useCallback } from 'react'
import PageTypeIdentifier from '@usap/carparts/src/shared/helpers/PageTypeIdentifier'
import { FooterQandAContainer, StatsText, ViewAllQandAText } from './style/QuestionAnswerBox.css'

export default function QuestionAnswerFooter({
  numberOfQuestions,
  numberOfAnswers,
  productUrl,
  Link,
}) {
  const onClick = useCallback(() => PageTypeIdentifier.pdp(), [])

  return (
    <FooterQandAContainer>
      <StatsText>
        { numberOfQuestions > 1 ? `${numberOfQuestions} Questions, ` : `${numberOfQuestions} Question, `}
        { numberOfAnswers > 1 ? `${numberOfAnswers} Answers` : `${numberOfAnswers} Answer`}
      </StatsText>
      <Link
        to={`${productUrl}#questionAnswer`}
        onClick={onClick}
      >
        <ViewAllQandAText>
          View all Q&As &gt;
        </ViewAllQandAText>
      </Link>
    </FooterQandAContainer>
  )
}
